import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
export const Grid = () => {
    const [showGridLines, setShowGridLines] = useState(true);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (event.ctrlKey && event.shiftKey && (Number(event.key) === 4) || event.key === '$' ) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown',toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    if (!showGridLines) {
        return null;
    }

    return (
        <div
            className='fixed inset-0 pointer-events-none'
            style={{ zIndex: '9999' }}>
            <div className='layout-container h-screen'>
                <div className='flex flex-wrap h-full'>
                    {Array(12).fill(null).map((_, i) => {
                        const classes = ['h-full'];

                        if (i >= 4 && i < 6) {
                            classes.push('hidden sm:block');
                        }

                        if (i >= 6) {
                            classes.push('hidden md:block');
                        }

                        return (
                            <div
                                className='h-full w-3/12 sm:w-2/12 md:w-1/12 px-10 sm:px-5 md:px-10'
                                key={i}>
                                <div
                                    className={classes.join(' ')}
                                    style={{ backgroundColor: '#ff00000f' }} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Grid;
